import isPropValid from '@emotion/is-prop-valid';
import { css } from '@emotion/react';
import styled from '@emotion/styled';

import { WithRequiredProperty } from '@skippay/core/@types/common';
import { media } from '@skippay/core/styles/media';
import { size } from '@skippay/core/styles/spacing';
import { color } from '@skippay/core/styles/variables';

import { SizeType, TextProps } from './@types/textProps';

const getDesktopFontSize = (sizeType: SizeType) => {
	switch (sizeType) {
		case 'h1':
			return css`
				font-size: ${size(7)};
				line-height: 1.4;
			`;
		case 'h2':
			return css`
				font-size: ${size(6)};
				line-height: 1.4;
			`;
		case 'h3':
			return css`
				font-size: ${size(5)};
				line-height: 1.4;
			`;
		case 'h4':
		case 'h5':
		case 'h6':
			return css`
				font-size: ${size(4)};
				line-height: 1.4;
			`;
		case 'paragraphSmall':
			return css`
				font-size: ${size(3)};
				line-height: 1.6;
			`;
		default:
			return css`
				font-size: ${size(4)};
				line-height: 1.6;
			`;
	}
};

const getMobileFontSize = (sizeType: SizeType) => {
	switch (sizeType) {
		case 'h1':
			return css`
				font-size: ${size(6)};
				line-height: 1.4;
			`;
		case 'h2':
			return css`
				font-size: ${size(5)};
				line-height: 1.4;
			`;
		case 'h3':
			return css`
				font-size: ${size(4)};
				line-height: 1.4;
			`;
		case 'h4':
		case 'h5':
		case 'h6':
			return css`
				font-size: 14px;
				line-height: 1.4;
			`;
		case 'paragraphSmall':
			return css`
				font-size: ${size(3)};
				line-height: 1.6;
			`;
		default:
			return css`
				font-size: 14px;
				line-height: 1.6;
			`;
	}
};

export const SText = styled('span', {
	shouldForwardProp: (prop) => isPropValid(prop),
})<WithRequiredProperty<TextProps, 'size' | 'weight'>>`
	margin-bottom: 0;
	position: relative;
	font-weight: ${({ weight }) => weight};
	${({ color: textColor }) =>
		textColor &&
		css`
			color: ${color(textColor)};
		`};
	${({ align }) =>
		align &&
		css`
			text-align: ${align};
			display: block;
		`};
	${({ transform }) =>
		transform &&
		css`
			text-transform: ${transform};
		`};
	${({ decoration }) =>
		decoration &&
		css`
			text-decoration: ${decoration};
		`};
	.dark & {
		${({ color: textColor, colorDarkMode }) =>
			colorDarkMode
				? css`
						color: ${color(colorDarkMode)};
				  `
				: textColor &&
				  css`
						color: ${color(textColor, 'dark')};
				  `}
	}
	${({ size: sizeType }) => getMobileFontSize(sizeType)};
	@media ${media.gt('MD')} {
		${({ size: sizeType }) => getDesktopFontSize(sizeType)};
	}
`;
